import { useState, useEffect } from "react";
import { getQueryParam, updateQueryParam } from "shared/lib";
import { useDebouncedValue } from "./useDebouncedValue";

const useDebouncedTableFilter = (queryKey: string, delay: number) => {
  const initialValue = getQueryParam(queryKey);
  const [value, setValue] = useState<string>(initialValue);

  const debouncedValue = useDebouncedValue(value, delay);

  const handleFilterChange = (
    e: React.ChangeEvent<HTMLInputElement> | string
  ) => {
    const newValue = typeof e === "string" ? e : e.target.value;
    setValue(newValue);
  };

  const clearFilterValue = () => {
    setValue("");
  };

  useEffect(() => {
    updateQueryParam(queryKey, value);
  }, [value, queryKey]);

  return {
    value,
    handleFilterChange,
    debouncedValue,
    clearFilterValue,
  };
};

export { useDebouncedTableFilter };
